import FormField from './FormField';

/*
  16px INPUTS, AT EVERY WIDTH, EVEN THOUGH THE BODY TEXT IS 14px. Do not "fix" this
  inconsistency.

  iOS Safari zooms the viewport whenever a focused input is under 16px. At 14px, every tap on a
  field of this payment form jolts the page. The original value here was `text-base sm:text-sm`,
  which had the right instinct but the wrong scope: it protected phones by breakpoint rather than
  stating the rule, so the fields ended up as the smallest text on the page everywhere else.

  The rule is about form controls only. Labels, prices and body copy are unaffected by the zoom
  behavior and sit at the 14px body size. typeScale.test.jsx pins this.

  44px minimum height, so the tap target holds up on a phone.
*/
const BASE_CLASSES =
  'block w-full min-h-[44px] rounded-sm px-3 py-2 text-base focus:ring-2 focus:ring-primary-500';

/**
 * Standard text input wired through FormField, so the label/error association is automatic.
 *
 * @param {object} props
 * @param {string} props.name
 * @param {object} props.field       entry from CUSTOMER_FIELDS
 * @param {string} props.value
 * @param {string} [props.error]
 * @param {Function} props.onChange  (name, value) => void
 * @param {Function} props.onBlur    (name, value) => void
 * @param {React.Ref} [props.inputRef]
 */
export default function TextField({ name, field, value, error, onChange, onBlur, inputRef }) {
  return (
    <FormField id={name} label={field.label} required={field.required} error={error} hint={field.hint}>
      {({ id, describedBy, invalid }) => (
        <input
          ref={inputRef}
          id={id}
          name={name}
          type={field.type || 'text'}
          value={value}
          autoComplete={field.autoComplete}
          inputMode={field.inputMode}
          placeholder={field.placeholder}
          aria-describedby={describedBy}
          aria-invalid={invalid || undefined}
          // `required` is intentionally omitted: this form surfaces its own messages, and the
          // native bubble would fire first and duplicate them.
          onChange={(e) => onChange(name, e.target.value)}
          onBlur={(e) => onBlur(name, e.target.value)}
          className={`${BASE_CLASSES} ${
            invalid ? 'border-red-500 focus:border-red-500' : 'border-gray-300 focus:border-primary-500'
          }`}
        />
      )}
    </FormField>
  );
}

export { BASE_CLASSES };
